import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'

import Typography from '@segment/matcha/components/Typography'
import Divider from '@segment/matcha/components/Divider'

import DemoForm from '@segment/templates/Forms/DemoForm'

const copy = {
  heading: `Interested in hearing more about how Segment can help you?`,
  description: `Connect with a Segment expert who can share more about what Segment can do for you.`,
}

const Form: FC<PropsWithChildren<unknown>> = () => {
  return (
    <Wrapper>
      <Divider />
      <Inner>
        <Typography variant="h2" tag="h2">
          {copy.heading}
        </Typography>
        <Typography variant="pLarge">{copy.description}</Typography>
        <FormWrapper>
          <DemoForm
            isProgressive={true}
            customFormIdentifier="site-datahub-demo"
            customTrackingType="site-datahub-demo"
            successMessageAppearance="twilioLight"
          />
        </FormWrapper>
      </Inner>
      <Divider />
    </Wrapper>
  )
}

export default Form

const Wrapper = styled.div``

const Inner = styled.div`
  padding: 16px 0 35px;
`

const FormWrapper = styled.div`
  max-width: 417px;
`
